import React, { useMemo } from 'react'
import { deleteCookie, inIframe, useEffectOnce, usePathParam } from '@chilecompra/react-kit'
import { REACT_APP_BASE_URL, REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import { PATH_PARAM } from '../config/settings/regexes'
import routes from '../config/settings/routes'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import HeadingSectionContainer from '../containers/Sanction/SanctionHeader.container'
import SanctionAttachmentsContainer from '../containers/Sanction/SanctionAttachments.container'
import SanctionEntryFormContainer from '../containers/Sanction/SanctionEntryForm.container'
import SanctionFooterContainer from '../containers/Sanction/SanctionFooter.container'
import SanctionHeadingContainer from '../containers/Sanction/SanctionHeadingSection.container'
import SanctionPOBiddingContainer from '../containers/Sanction/SanctionPOBidding.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import NotFoundPage from '../pages/NotFound'

/**
 * The Register Sanction' page.
 */
const RegisterSanction = () => {
  const dni = usePathParam('rut')

  const handleClickHome = event => {
    event.preventDefault()
    deleteCookie('access_token')
    window.open(`${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`, '_top')
  }

  const breadcrumbs = [
    {
      text: 'Escritorio',
      link: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
      isExternal: true,
      onClick: handleClickHome
    },
    {
      text: 'Búsqueda Proveedor',
      link: `${REACT_APP_BASE_URL}/busqueda`,
      isExternal: true
    },
    {
      text: dni,
      link: routes.contractualBehavior.replace(PATH_PARAM, dni),
      isExternal: false
    },
    {
      text: 'Registrar sanción'
    }
  ]

  const isInIframe = useMemo(() => {
    return inIframe()
  }, [])

  useEffectOnce(() => {
    if (isInIframe) {
      window.parent.postMessage(
        {
          action: 'scrollTo',
          value: {
            x: 0,
            y: 0
          }
        },
        REACT_APP_MERCADO_PUBLICO_BASE_URL
      )
    } else {
      window.scrollTo(0, 0)
    }
  })

  return (
    <ProtectByFeatures rule={features => features['com.seller/contractual.behavior']} fallback={() => <NotFoundPage />}>
      <AuthorizationProviderContainer>
        <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => <NotFoundPage />}>
          <BrandLayout featured={<HeadingSectionContainer breadcrumbs={breadcrumbs} />}>
            <SanctionHeadingContainer />
            <SanctionPOBiddingContainer />
            <SanctionEntryFormContainer />
            <SanctionAttachmentsContainer />
            <SanctionFooterContainer />
          </BrandLayout>
        </ProtectByProfile>
      </AuthorizationProviderContainer>
    </ProtectByFeatures>
  )
}

export default RegisterSanction
